import { Form, Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { useEffect } from 'react';

/**
 * SearchBox component that renders a search input box with a placeholder and a search icon.
 *
 * @component
 * @example
 * const searchPlaceholder = "Search...";
 * const handleSearch = (value) => {
 * };
 * return (
 *   <SearchBox searchPlaceholder={searchPlaceholder} handleSearch={handleSearch} />
 * )
 *
 * @param {Object} props - Component props.
 * @param {string} props.searchPlaceholder - The placeholder text for the search input.
 * @param {function} props.handleSearch - The function to call when the search input value changes.
 * @returns {React.Element} The rendered component.
 */
const SearchBox = ({
  searchPlaceholder,
  handleSearch,
  inputRef = null,
  firstRowRef = null,
  modalVisible = false,
  isUppercase = false,
}) => {
  useEffect(() => {
    inputRef?.current?.focus();
  }, []);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '10px',
        // width: '50%',
      }}
    >
      <Form.Item name="search_item" noStyle>
        <Input
          className="header-search"
          ref={inputRef}
          style={{
            width: '100%',
          }}
          placeholder={searchPlaceholder}
          onKeyDown={(e) => {
            if (e.code === 'ArrowDown') {
              e.preventDefault();
              firstRowRef?.current?.focus();
            }
          }}
          onInput={(e) => {
            e.target.value = isUppercase
              ? e.target.value.toUpperCase()
              : e.target.value;
          }}
          onChange={(e) => handleSearch(e.target.value)}
          prefix={<SearchOutlined />}
        />
      </Form.Item>
    </div>
  );
};

export default SearchBox;
